import React from 'react';
import { ScarabIcon } from '../constants';
import { SiteContent } from '../content';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const { signup, quote, columns } = SiteContent.footer;
  
  return (
    <footer className="bg-rich-black text-[#F5F0E6] pt-24 md:pt-40 pb-12 overflow-hidden relative">
      <div className="absolute -left-20 -bottom-20 opacity-[0.03] pointer-events-none">
        <ScarabIcon className="w-[800px] h-[800px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 mb-40">
          <div className="lg:col-span-6">
            <h3 className="hero-title !text-4xl md:!text-6xl mb-10 leading-none">{signup.title}</h3>
            <form className="flex w-full max-w-lg border-b-2 border-[#A65D3F] pb-4">
              <input 
                type="email" 
                placeholder={signup.placeholder} 
                className="bg-transparent border-none outline-none flex-grow text-sm tracking-widest uppercase placeholder:text-white/20 text-[#F5F0E6]"
              />
              <button className="text-xs tracking-widest uppercase font-black text-[#A65D3F] hover:text-white transition-colors ml-4">
                {signup.button}
              </button>
            </form>
          </div>
          
          <div className="lg:col-span-6 grid grid-cols-3 gap-8">
            <div className="flex flex-col space-y-6">
              <div className="flex items-center space-x-2">
                 <span className="text-[10px] font-black opacity-20">01</span>
                 <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-[#A65D3F]">Movement</h4>
              </div>
              {columns.movement.map(item => (
                 <Link key={item} to={`/${item.toLowerCase()}`} className="text-xs font-bold opacity-50 hover:opacity-100 transition-opacity uppercase tracking-widest">{item}</Link>
              ))}
            </div>
            <div className="flex flex-col space-y-6">
              <div className="flex items-center space-x-2">
                 <span className="text-[10px] font-black opacity-20">02</span>
                 <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-[#A65D3F]">Shop</h4>
              </div>
              {columns.shop.map(item => (
                 <span key={item} className="text-xs font-bold opacity-50 hover:opacity-100 transition-opacity uppercase tracking-widest cursor-pointer">{item}</span>
              ))}
            </div>
            <div className="flex flex-col space-y-6">
              <div className="flex items-center space-x-2">
                 <span className="text-[10px] font-black opacity-20">03</span>
                 <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-[#A65D3F]">Connect</h4>
              </div>
              {columns.connect.map(item => (
                 <span key={item} className="text-xs font-bold opacity-50 hover:opacity-100 transition-opacity uppercase tracking-widest cursor-pointer">{item}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mb-24 max-w-3xl mx-auto">
          <p className="serif italic text-[#C9A227] text-2xl md:text-3xl leading-snug">
            "{quote}"
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-12 border-t border-white/5 text-[10px] tracking-[0.5em] uppercase opacity-30">
          <div className="flex items-center space-x-4 mb-6 md:mb-0">
             <ScarabIcon className="w-6 h-6" />
             <p>EARTH RIGHTS BUSINESS — MMXXV</p>
          </div>
          <div className="flex space-x-12">
            <a href="#" className="hover:text-white transition-colors">Terms of Alignment</a>
            <a href="#" className="hover:text-white transition-colors">The Ledger</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;